/**
 * banniere.js
 */

// Import
import "./banniere.scss";
import $ from 'jquery';

$(document).ready(function() {
    var caption_height = $('.slides .caption-wrap').height();
    $('.slides>li').css('padding-bottom', caption_height+'px');
});



